"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_CODE_NOT_FOUND = exports.ObjectTypeV1ToV0 = exports.ObjectTypeV0ToV1 = exports.ObjectTypeV0 = exports.ObjectTypeV1 = exports.SeverityValueArray = exports.SeverityLabelArray = exports.PAPLabelArray = exports.PAPValueArray = exports.TLPLabelArray = exports.TLPValueArray = void 0;
exports.TLPValueArray = [0, 1, 2, 3, 4];
exports.TLPLabelArray = ['clear', 'green', 'amber', 'amber+strict', 'red'];
exports.PAPValueArray = [0, 1, 2, 3];
exports.PAPLabelArray = ['clear', 'green', 'amber', 'red'];
exports.SeverityLabelArray = ['low', 'medium', 'high', 'critical'];
exports.SeverityValueArray = [1, 2, 3, 4];
var ObjectTypeV1;
(function (ObjectTypeV1) {
    ObjectTypeV1["ACTION"] = "action";
    ObjectTypeV1["ALERT"] = "alert";
    ObjectTypeV1["ALERT_STATUS"] = "alertStatus";
    ObjectTypeV1["ANY"] = "any";
    ObjectTypeV1["ANALYZER_TEMPLATE"] = "analyzer_template";
    ObjectTypeV1["AUDIT"] = "audit";
    ObjectTypeV1["CASE"] = "case";
    ObjectTypeV1["CASE_REPORT_TEMPLATE"] = "caseReportTemplate";
    ObjectTypeV1["CASE_STATUS"] = "caseStatus";
    ObjectTypeV1["CASE_TEMPLATE"] = "caseTemplate";
    ObjectTypeV1["COMMENT"] = "comment";
    ObjectTypeV1["CUSTOM_EVENT"] = "customEvent";
    ObjectTypeV1["CUSTOM_FIELD"] = "customField";
    ObjectTypeV1["ATTACK_PATTERNS"] = "pattern";
    ObjectTypeV1["CATALOG_ATTACK_PATTERNS"] = "catalog";
    ObjectTypeV1["DASHBOARD"] = "dashboard";
    ObjectTypeV1["FUNCTION"] = "function";
    ObjectTypeV1["JOB"] = "job";
    ObjectTypeV1["LOG"] = "log";
    ObjectTypeV1["OBSERVABLE"] = "observable";
    ObjectTypeV1["OBSERVABLE_TYPE"] = "observableType";
    ObjectTypeV1["ORGANISATION"] = "organisation";
    ObjectTypeV1["PAGE_TEMPLATE"] = "pageTemplate";
    ObjectTypeV1["PROCEDURE"] = "procedure";
    ObjectTypeV1["PROFILE"] = "profile";
    ObjectTypeV1["SHARE"] = "share";
    ObjectTypeV1["TASK"] = "task";
    ObjectTypeV1["TAXONOMY"] = "taxonomy";
    ObjectTypeV1["TAG"] = "tag";
    ObjectTypeV1["USER"] = "user";
})(ObjectTypeV1 = exports.ObjectTypeV1 || (exports.ObjectTypeV1 = {}));
var ObjectTypeV0;
(function (ObjectTypeV0) {
    ObjectTypeV0["ACTION"] = "action";
    ObjectTypeV0["ALERT"] = "alert";
    ObjectTypeV0["ALERT_STATUS"] = "alertStatus";
    ObjectTypeV0["AUDIT"] = "audit";
    ObjectTypeV0["CASE"] = "case";
    ObjectTypeV0["CASE_STATUS"] = "caseStatus";
    ObjectTypeV0["CASE_TEMPLATE"] = "caseTemplate";
    ObjectTypeV0["CUSTOM_FIELD"] = "customField";
    ObjectTypeV0["ATTACK_PATTERNS"] = "pattern";
    ObjectTypeV0["CATALOG_ATTACK_PATTERNS"] = "catalog";
    ObjectTypeV0["JOB"] = "job";
    ObjectTypeV0["LOG"] = "log";
    ObjectTypeV0["OBSERVABLE"] = "observable";
    ObjectTypeV0["COMMENT"] = "comment";
    ObjectTypeV0["OBSERVABLE_TYPE"] = "observableType";
    ObjectTypeV0["ORGANISATION"] = "organisation";
    ObjectTypeV0["PROCEDURE"] = "procedure";
    ObjectTypeV0["PROFILE"] = "profile";
    ObjectTypeV0["TASK"] = "task";
    ObjectTypeV0["TAXONOMY"] = "taxonomy";
    ObjectTypeV0["TAG"] = "tag";
    ObjectTypeV0["USER"] = "user";
})(ObjectTypeV0 = exports.ObjectTypeV0 || (exports.ObjectTypeV0 = {}));
exports.ObjectTypeV0ToV1 = {
    action: ObjectTypeV1.ACTION,
    alert: ObjectTypeV1.ALERT,
    analyzer_template: ObjectTypeV1.ANALYZER_TEMPLATE,
    audit: ObjectTypeV1.AUDIT,
    case: ObjectTypeV1.CASE,
    caseTemplate: ObjectTypeV1.CASE_TEMPLATE,
    case_artifact: ObjectTypeV1.OBSERVABLE,
    case_artifact_job: ObjectTypeV1.JOB,
    case_task: ObjectTypeV1.TASK,
    case_task_log: ObjectTypeV1.LOG,
    customField: ObjectTypeV1.CUSTOM_FIELD,
    dashboard: ObjectTypeV1.DASHBOARD,
    observableType: ObjectTypeV1.OBSERVABLE_TYPE,
    organisation: ObjectTypeV1.ORGANISATION,
    profile: ObjectTypeV1.PROFILE,
    user: ObjectTypeV1.USER,
};
exports.ObjectTypeV1ToV0 = {
    observable: 'case_artifact',
    task: 'case_task',
    log: 'case_task_log',
};
exports.STATUS_CODE_NOT_FOUND = 404;
